import * as React from 'react';
import { useIntl } from 'react-intl';

import { messages } from './messages';
import { Container, Icon, SectionTitle } from './styled';
import TrimenSvg from './Trimen.svg';
import { useOtherTab } from './useOtherTab';

export const Other = () => {
  const { formatMessage } = useIntl();
  const {
    specialStorage,
    importantNotice,
    manufacturerImporter,
    producerPostalAddress,
    contactAddress,
    postalAddress,
    isFranceShop,
  } = useOtherTab();

  return (
    <Container id="pdOthersTab">
      {isFranceShop && <Icon src={TrimenSvg} />}

      {specialStorage && (
        <>
          <SectionTitle>{formatMessage(messages.specialStorage)}</SectionTitle>
          <div dangerouslySetInnerHTML={{ __html: specialStorage }} />
        </>
      )}

      {importantNotice && (
        <>
          <SectionTitle>{formatMessage(messages.importantNotice)}</SectionTitle>
          <div dangerouslySetInnerHTML={{ __html: importantNotice }} />
        </>
      )}

      {(producerPostalAddress ||
        contactAddress ||
        postalAddress ||
        manufacturerImporter) && (
        <>
          <SectionTitle>
            {formatMessage(messages.manufacturerImporter)}
          </SectionTitle>
          <ul>
            {postalAddress && <li>{postalAddress}</li>}
            {contactAddress && <li>{contactAddress}</li>}
            {producerPostalAddress && (
              <li>
                {formatMessage(messages.manufacturerImporter)}{' '}
                {producerPostalAddress}
              </li>
            )}
          </ul>

          {manufacturerImporter && !producerPostalAddress && (
            <div
              style={{ marginTop: '-12px' }}
              dangerouslySetInnerHTML={{ __html: manufacturerImporter }}
            />
          )}
        </>
      )}
    </Container>
  );
};
